<template>
  <v-app>
    <v-app-bar app clipped-right color="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-spacer/>
      <v-tabs dark icons-and-text color="white" hide-slider optional right v-if="$vuetify.breakpoint.mdAndUp">
        <v-tab :to="{name: 'Dashboard'}">
          <small class="mt-2">Dashboard</small>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-tab>

        <v-tab :to="{name: 'Study groups'}">
          <small class="mt-2">Study groups</small>
          <v-icon>mdi-account-multiple</v-icon>
        </v-tab>

        <v-tab :to="{name: 'Classroom'}">
          <small class="mt-2">Classroom</small>
          <v-icon>mdi-google-classroom</v-icon>
        </v-tab>

        <v-tab v-if="profile_type && profile_type !== 'aspiringSolicitor'"
               :to="{name: 'Working Hours'}">
          <small class="mt-2">Working Hours</small>
          <v-icon>mdi-briefcase-clock</v-icon>
        </v-tab>

        <v-tab :to="{name: 'Calendar'}">
          <small class="mt-2">Calendar</small>
          <v-icon>mdi-calendar</v-icon>
        </v-tab>


        <v-menu v-model="notificationsMenu" bottom left offset-y origin="top right" transition="scale-transition">
          <template v-slot:activator="{ attrs, on }">
            <v-tab v-bind="attrs" v-on="on">
              <small class="mt-2">Notifications</small>
<!---->
              <template v-if="notifications.length > 0">
                <v-badge color="error" overlap>
                  <template v-slot:badge>
                    <span class="caption">{{ notifications.length }}</span>
                  </template>
                  <v-icon>mdi-bell</v-icon>
                </v-badge>
              </template>
              <template v-else>
                <v-icon>mdi-bell</v-icon>
              </template>
            </v-tab>
          </template>

          <v-list :tile="false" nav>
            <v-list-item v-if="notifications.length === 0">
              <v-list-item-content>
                <v-list-item-subtitle>Empty</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>


            <template  v-for="item in notifications">
              <v-list-item v-if="item.type === 'ClientRequest'" :key="item.id"
                           :to="{name: 'Edit study members', params: {study_group_id: item.data.study_group_id}}"
                           @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="`A new candidate has requested to join course.`"/>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-else-if="item.type === 'ClientRequestApproved'" :key="item.id"
                           :to="{name: 'Study group', params: {study_group_id: item.data.study_group_id}}"
                           @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="`You have been successfully enrolled on the study group you applied for`"/>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-else-if="item.type === 'ClientRequestRejected'" :key="item.id"
                           @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="`Your request has unfortunately been rejected`"/>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-else-if="item.type === 'InvoiceCreated'" :key="item.id"
                           :to="{name: 'Payments', params: {order_id: item.data.id}}"
                           @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="`A new invoice created`"/>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-else :key="item.id" @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="item.type"/>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>

        <v-menu bottom left min-width="200" offset-y origin="top right" transition="scale-transition">
          <template v-slot:activator="{ attrs, on }">
            <v-tab v-bind="attrs" v-on="on">
              <small class="mt-2">Profile</small>
              <v-icon>mdi-account</v-icon>
            </v-tab>
          </template>

          <v-list :tile="false" flat dense nav>
            <v-list-item :to="{name: 'Profile'}" class="py-0">
              <v-list-item-content>
                <v-list-item-title>Settings</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider/>
            <v-list-item :to="{name: 'Login'}" class="py-0">
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-tabs>

      <v-tabs dark icons-and-text color="white" hide-slider optional right v-else>
        <v-menu v-model="notificationsMenu" bottom left offset-y origin="top right" transition="scale-transition">
          <template v-slot:activator="{ attrs, on }">
            <v-tab v-bind="attrs" v-on="on">
              <small class="mt-2">Notifications</small>
              <!---->
              <template v-if="notifications.length > 0">
                <v-badge color="error" overlap>
                  <template v-slot:badge>
                    <span class="caption">{{ notifications.length }}</span>
                  </template>
                  <v-icon>mdi-bell</v-icon>
                </v-badge>
              </template>
              <template v-else>
                <v-icon>mdi-bell</v-icon>
              </template>
            </v-tab>
          </template>

          <v-list :tile="false" nav>
            <v-list-item v-if="notifications.length === 0">
              <v-list-item-content>
                <v-list-item-subtitle>Empty</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>


            <template  v-for="item in notifications">
              <v-list-item v-if="item.type === 'ClientRequest'" :key="item.id"
                           :to="{name: 'Edit study members', params: {study_group_id: item.data.study_group_id}}"
                           @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="`A new candidate has requested to join course.`"/>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-else-if="item.type === 'ClientRequestApproved'" :key="item.id"
                           :to="{name: 'Study group', params: {study_group_id: item.data.study_group_id}}"
                           @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="`You have been successfully enrolled on the study group you applied for`"/>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-else-if="item.type === 'ClientRequestRejected'" :key="item.id"
                           @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="`Your request has unfortunately been rejected`"/>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-else-if="item.type === 'InvoiceCreated'" :key="item.id"
                           :to="{name: 'Payments', params: {order_id: item.data.id}}"
                           @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="`A new invoice created`"/>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-else :key="item.id" @click="markNotificationRead(item)">
                <v-list-item-content>
                  <v-list-item-title v-text="item.type"/>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
        <v-menu bottom left min-width="200" offset-y origin="top right" transition="scale-transition">
          <template v-slot:activator="{ attrs, on }">
            <v-tab v-bind="attrs" v-on="on">
              <small class="mt-2">Profile</small>
              <v-icon>mdi-account</v-icon>
            </v-tab>
          </template>

          <v-list :tile="false" flat dense nav>
            <v-list-item :to="{name: 'Profile'}" class="py-0">
              <v-list-item-content>
                <v-list-item-title>Settings</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider/>
            <v-list-item :to="{name: 'Login'}" class="py-0">
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-tabs>
    </v-app-bar>



    <v-navigation-drawer app :mini-variant="!$vuetify.breakpoint.mobile && $vuetify.breakpoint.mdAndUp"
                         width="260"
                         v-model="drawer"
                         :expand-on-hover="!$vuetify.breakpoint.mobile && $vuetify.breakpoint.mdAndUp"
                         :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
                         :src="require(`@/assets/barImg.svg`)"
                         v-bind="$attrs"
    >
      <template v-slot:prepend>
        <v-list class="pa-0">
          <v-list-item two-line class="px-2 py-0" :to="{name: 'Dashboard'}">
            <v-list-item-content class="py-1">
              <v-list-item-title class="text-uppercase d-flex align-center font-weight-regular">
              <span class="logo-mini">
                  <v-img :src="require(`@/assets/logo_mini.png`)" width="38px"/>
              </span>
                <span class="logo-normal px-1">
                <v-img :src="require(`@/assets/logo.png`)" max-width="190px"/>
              </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider/>

          <v-list-item v-if="authUser" class="pa-2 text-no-wrap" three-line-line :to="{name: 'Profile'}" dense>
            <v-list-item-avatar v-if="authUser.logo" size="40px">
              <img :src="authUser.logo" alt="avatar">
            </v-list-item-avatar>

            <v-list-item-avatar v-else size="40px" color="success">
              {{ authUser.first_name.slice(0,1) }}  {{ authUser.last_name ? authUser.last_name.slice(0,1) : null }}
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ authUser.full_name }}</v-list-item-title>
              <v-list-item-subtitle>{{ profile_type_label }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
        </v-list>


      </template>
      <template v-slot:img="props">
        <v-img :gradient="`to bottom, rgba(145,144,181, .9), rgba(145,144,181, .8)`" v-bind="props"/>
      </template>

<!--      <v-list dense nav class="pa-0">-->
<!--        <v-list-item>-->
<!--          <v-list-item-icon>-->
<!--            &lt;!&ndash;          <v-icon>mdi-calendar-plus</v-icon>&ndash;&gt;-->
<!--          </v-list-item-icon>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>{{ authUserTimezone }}</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
<!--      </v-list>-->

<!--      <v-divider/>-->

      <v-list dense nav>
        <v-list-item :to="{name: 'Dashboard'}">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Dashboard
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'Study groups'}">
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
            <v-badge v-if="authUserStudyGroupInvites" color="success" :content="authUserStudyGroupInvites"/>
          </v-list-item-icon>
          <v-list-item-content class="text-no-wrap">
            Study groups
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="profile_type && profile_type === 'aspiringSolicitor'" :to="{name: 'Booking'}">
          <v-list-item-icon>
            <v-icon>mdi-calendar-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Booking
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'Classroom'}">
          <v-list-item-icon>
            <v-icon>mdi-google-classroom</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Classroom
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="profile_type && profile_type !== 'aspiringSolicitor'" :to="{name: 'Working Hours'}">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="text-no-wrap">
            Working hours
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'Calendar'}">
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Calendar
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="profile_type && profile_type === 'aspiringSolicitor'" :to="{name: 'Invoices'}">
          <v-list-item-icon>
            <v-icon>mdi-receipt</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Invoices
          </v-list-item-content>
        </v-list-item>

        <template v-if="authUserCourseLeader || authUserAdmin">
          <v-divider/>
          <v-subheader class="pa-0">COURSE</v-subheader>
          <v-divider/>
        </template>

        <v-list-item v-if="authUserCourseLeader" :to="{name: 'General schedule'}">
          <v-list-item-icon>
            <v-icon>mdi-calendar-star</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="text-no-wrap">
            General schedule
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="authUserCourseLeader" :to="{name: 'Study cycles'}">
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="text-no-wrap">
            Cycle schedule
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="authUserCourseLeader || authUserAdmin" :to="{name: 'Sessions'}">
          <v-list-item-icon>
            <v-icon>mdi-calendar-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="text-no-wrap">
            Sessions
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="authUserCourseLeader || authUserAdmin" :to="{name: 'Payments'}">
          <v-list-item-icon>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Payments
          </v-list-item-content>
        </v-list-item>

        <v-list-group v-if="authUserCourseLeader || authUserAdmin" color="white" prepend-icon="mdi-account-group">
          <template v-slot:activator>
            <v-list-item-title>Members</v-list-item-title>
          </template>

          <v-list-item :to="{name: 'Tutors'}" v-if="authUserCourseLeader">
            <v-list-item-icon>
              <v-icon>mdi-account-star</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-no-wrap">
              Tutors
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'Students'}" v-if="authUserCourseLeader || authUserAdmin">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-no-wrap">
              Students
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group v-if="authUserCourseLeader" color="white" prepend-icon="mdi-server">
          <template v-slot:activator>
            <v-list-item-title>Services</v-list-item-title>
          </template>

          <v-list-item :to="{name: 'Practice areas'}">
            <v-list-item-icon>
              <v-icon>mdi-alpha-p-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-no-wrap">
              Practice areas
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'Session types'}">
            <v-list-item-icon>
              <v-icon>mdi-alpha-s-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-no-wrap">
              Session types
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'Mocks'}">
            <v-list-item-icon>
              <v-icon>mdi-note-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-no-wrap">
              Mocks
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'Packages'}">
            <v-list-item-icon>
              <v-icon>mdi-package-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-no-wrap">
              Packages
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'Settings'}">
            <v-list-item-icon>
              <v-icon>mdi-cogs</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-no-wrap">
              Settings
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-divider/>
      <v-list-item dense two-line href="mailto:sqesmart.developers@gmail.com?Subject=Found%20mistake">
        <v-list-item-action>
          <v-icon>mdi-email-send</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Report a problem</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-slot:append>
        <v-list dense>
          <v-divider/>
          <div class="text-center">v{{ app_version }}</div>
          <v-divider/>
<!--          <v-list-item>-->
<!--&lt;!&ndash;            <v-list-item-action>© </v-list-item-action>&ndash;&gt;-->
<!--            <v-list-item-icon><v-icon>mdi-copyright</v-icon></v-list-item-icon>-->
<!--            <v-list-item-content class="text-no-wrap">Superexam {{ new Date().getFullYear() }}</v-list-item-content>-->
<!--          </v-list-item>-->

<!--          <v-divider/>-->
          <v-list-item :to="{name: 'Login'}">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-no-wrap">
              Logout
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-main>
      <router-view></router-view>
    </v-main>

    <NotificationSnackbar/>

    <v-footer app>
      <v-container :fluid="$vuetify.breakpoint.smAndDown" class="py-0">
        <v-row>
          <v-col class="py-0 d-flex align-content-center">
            <p class="my-2">{{ new Date().getFullYear() }} © Superexam</p>
          </v-col>
          <v-col class="py-0" v-if="$vuetify.breakpoint.smAndUp">
            <v-chip-group>
              <v-chip small outlined link target="_blank" href="https://qltsosce.co.uk/terms-conditions-supply">TERMS & CONDITIONS OF SUPPLY</v-chip>
              <v-chip small outlined link target="_blank" href="https://qltsosce.co.uk/terms-use">TERMS OF USE</v-chip>
              <v-chip small outlined link target="_blank" href="https://qltsosce.co.uk/privacy-policy">PRIVACY POLICY</v-chip>
              <v-chip small outlined link target="_blank" href="https://qltsosce.co.uk/cookie-policy">COOKIE POLICY</v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <v-overlay :value="app_loading" z-index="1000" dark>
      <!--    <v-overlay :value="true" z-index="1000" dark>-->
      <v-progress-circular indeterminate size="120" color="success">
        <v-avatar size="115px" color="primary" class="box-shadow">
          <v-img :src="require(`@/assets/logo_mini2.png`)"/>
        </v-avatar>
      </v-progress-circular>
    </v-overlay>

    <v-dialog v-model="app_update_exists" max-width="400px">
      <v-alert class="ma-0" prominent color="blur" dark icon="mdi-progress-download">
        <v-row align="center">
          <v-col class="grow">
            An update is available
          </v-col>
          <v-col class="shrink">
            <v-btn color="success" class="box-shadow" block @click="appRefresh">Update!</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>
  </v-app>
</template>

<script>
import {mapActions} from "vuex";
import NotificationSnackbar from '../components/NotificationSnackbar'

export default {
  components: {
    NotificationSnackbar
  },
  data: () => ({
    barColor: 'rgba(145,144,181, .9), rgba(145,144,181, .8)',
    drawer: true,
    notificationsMenu: false,
    notifications: [],
    interval: null,
  }),
  computed: {
    authUserStudyGroupInvites: function () {
      if(this.authUserStudyGroups.length > 0) {
        return this.authUserStudyGroups.filter(item => item.status === 'invited').length
      }
      return null
    }
  },
  watch: {
    '$vuetify.breakpoint.smAndDown' (val) {
      this.$emit('update:expandOnHover', !val)
    },
  },
  created() {
    this.loadUser()
    this.loadSessionTypes()
    this.loadPracticeAreas()
    this.loadStudyGroups()
    this.loadAuthUserSessionLimits()
    this.loadNotifications()
  },
  // beforeDestroy() {
  //   clearInterval(this.interval)
  // },
  methods: {
    ...mapActions({
      loadUser: 'loadUser',
      loadSessionTypes: 'loadSessionTypes',
      loadPracticeAreas: 'loadPracticeAreas',
      loadStudyGroups: 'loadAuthUserStudyGroups',
      loadAuthUserSessionLimits: 'loadAuthUserSessionLimits',
    }),
    loadNotifications() {
      this.interval = setInterval(() => {
        this.axios.get(`api/user/notifications`)
            .then(({data}) => {this.notifications = data.data})
      }, 1000 * 60);
    },
    markNotificationRead(item) {
      this.axios.put(`api/user/notifications/${item.id}`)
        .then(() => {this.notifications = this.notifications.filter(notification => notification.id !== item.id )})
    }
  }
}
</script>
